import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import CancelIcon from '@material-ui/icons/Cancel'
import InputAdornment from '@material-ui/core/InputAdornment'
import clsx from 'clsx'
import get from 'lodash/get'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: 33,
    width: 300,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRadius: 17,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
}))

export default React.memo(function CustomizedInputBase({
  className,
  placeholder = '',
  withSearchButton = true,
  input,
  inputProps,
  InputProps,
  InputLabelProps,
  variant = 'elevation',
  withClear = false,
  ...rest
}) {
  const classes = useStyles()
  const [hover, setHover] = useState(false)
  const toggleHover = () => {
    setHover((hover) => !hover)
  }

  // clear input value prop by final form
  const WithClear =
    withClear && !!get(input, 'value') ? (
      <InputAdornment>
        <IconButton size="small" color="primary" onClick={() => input.onChange({ target: { value: '' } })}>
          <CancelIcon />
        </IconButton>
      </InputAdornment>
    ) : null

  return (
    <Paper
      elevation={hover ? 2 : 0}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
      className={clsx(classes.root, className && className)}
      variant={variant}
    >
      {withSearchButton && (
        <IconButton size="small" type="submit">
          <SearchIcon />
        </IconButton>
      )}
      <InputBase
        className={classes.input}
        placeholder={placeholder}
        inputProps={{ ...inputProps }}
        endAdornment={WithClear}
        {...input}
        {...InputProps}
        {...rest}
      />
    </Paper>
  )
})
